import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';

import Loading from '../components/Loading';

import Route from './Route';

import SingIn from '../pages/SignIn';
import SingUp from '../pages/SignUp';

const Dashboard = lazy(() => import('../pages/Dashboard'));

const Routes: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path="/" exact component={SingIn} />
      <Route path="/singup" component={SingUp} />

      <Route path="/dashboard" component={Dashboard} isPrivate />
    </Switch>
  </Suspense>
);

export default Routes;
